module.exports = __webpack_public_path__ + "static/media/Barnas_Skog_Hele.b577fc45.pdf";